import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';

import { Text } from '../index';

import { StyledCard } from './style';

export const NoteCard = ({ value, onChange, style, ...rest }) => {
    return (
        <StyledCard style={style} {...rest}>
            <Text $bold>My note</Text>
            <TextField
                id="note-textfield"
                multiline
                minRows={6}
                variant="outlined"
                placeholder="What did you talk to your provider?"
                fullWidth
                style={{
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    marginTop: '15px',
                }}
                InputProps={{
                    style: {
                        borderRadius: '16px',
                    },
                }}
                value={value}
                onChange={onChange}
                disabled={!onChange}
                inputProps={{ maxLength: 2000 }}
            />
        </StyledCard>
    );
};

NoteCard.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    style: PropTypes.object,
    rest: PropTypes.object,
};
